'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var theme = require('../../consts/theme.js');
var ViewportConfigProvider = require('../../providers/ViewportConfigProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const BackdropContainer = styled__default["default"].div.withConfig({
  componentId: "sc-1jp0zte-0"
})(_ref => {
  let {
    offsetTop = 0,
    offsetBottom = 0,
    offsetLeft = 0,
    offsetRight = 0,
    s
  } = _ref;
  return {
    position: 'fixed',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: theme.zIndex.Modal,
    top: offsetTop,
    bottom: offsetBottom,
    left: offsetLeft,
    right: offsetRight,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    ...s
  };
});
const Backdrop = _ref2 => {
  let {
    s,
    children
  } = _ref2;
  const viewportConfig = ViewportConfigProvider.useViewportConfig();
  return /*#__PURE__*/React__default["default"].createElement(BackdropContainer, _extends__default["default"]({}, viewportConfig.anchor, {
    s: s
  }), children);
};

exports["default"] = Backdrop;
